import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { capitalize } from '@mui/material/utils';

interface EdgedButtonProps extends ButtonProps {
  edge: 'start' | 'end';
  className?: string;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    '&.edgeStart': {
      marginLeft: theme.spacing(-1),
    },
    '&.edgeEnd': {
      marginRight: theme.spacing(-1),
    },
  },
  sizeSmall: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

// TODO:
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const EdgedButton: React.FC<React.PropsWithChildren<EdgedButtonProps>> = forwardRef(
  ({ edge, className, ...props }, ref) => {
    const { classes, cx } = useStyles();
    return (
      <Button
        {...props}
        ref={ref}
        classes={classes}
        className={cx(`edge${capitalize(edge)}`, className)}
        variant="text"
      />
    );
  },
);

export default EdgedButton;
